__turbopack_context__.v({
  "imageWrapper": "_91UPAW_imageWrapper",
  "label": "_91UPAW_label",
  "labelReversed": "_91UPAW_labelReversed",
  "prize": "_91UPAW_prize",
  "prizeImage": "_91UPAW_prizeImage",
  "reversed": "_91UPAW_reversed",
  "soldOutStamp": "_91UPAW_soldOutStamp",
  "stepWrapper": "_91UPAW_stepWrapper",
  "textContent": "_91UPAW_textContent",
  "textContentReversed": "_91UPAW_textContentReversed",
  "title": "_91UPAW_title",
  "unavailable": "_91UPAW_unavailable",
});
